export default __webpack_public_path__ + "static/media/philip.924ceb61.jpg";